export default __webpack_public_path__ + "static/media/pers_pc.f96def1e.jpg";